import { action as apiAction } from 'api/Api'

type Payload = {
  boardId: number
  name: string
  color: number
}

export default (payload: Payload) => async () => {
  const { boardId, name, color } = payload

  await apiAction('AddLabel', {
    boardId,
    name: name.trim(),
    color
  })
}
